import React from 'react'
import styled from 'styled-components'

type Props = {
	icon: string
	title: string
	body: string
}

/** MTA card — blue-tinted card with an illustration, bold title and description. */
const GuestCard: React.FC<Props> = ({ icon, title, body }) => {
	return (
		<StyledGuestCard>
			<GuestCardImage src={icon} alt="" />
			<CardTitle>{title}</CardTitle>
			<CardText>{body}</CardText>
		</StyledGuestCard>
	)
}

/* Design card: white, bordered, centred — image ≤170×100, 14px title, 12px body. */
const StyledGuestCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	text-align: center;
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--r-xl);
	padding: 16px 14px;
`

const GuestCardImage = styled.img`
	width: 100%;
	max-width: 170px;
	height: 100px;
	object-fit: contain;
	display: block;
`

const CardTitle = styled.h3`
	margin: 0;
	font: var(--fw-bold) var(--fs-body) var(--font-sans);
	color: var(--text-primary);
`

const CardText = styled.p`
	margin: 0;
	font: var(--fw-regular) var(--fs-label)/1.7 var(--font-sans);
	color: var(--text-secondary);
`

export default GuestCard
